import { AppStateSlice } from '../stores/app_state';
import { TextToSpeechState } from './state';

/** TTS doesn't work on web, so just leave as stubs */
export const createTextToSpeechState: AppStateSlice<
  TextToSpeechState
> = () => ({
  setTTSEnabled() {
    return;
  },
  speak() {
    return;
  },

  speakIfEnabled() {
    return;
  },

  initTTS() {
    return;
  },
});
